import ROUTES from '../routes';
import GeographicalRisk from '../hoc/geographical/geographical';
import GeographicalRiskForm from '../hoc/geographical/form';

const GeogaphicalRoutes = {
  path: ROUTES.GEOGRAPHICAL,
  element: <GeographicalRisk />,
  children: [
    {
      path: ROUTES.GEOGRAPHICAL_ITEM,
      element: <GeographicalRiskForm />,
    },
  ],
};

export default GeogaphicalRoutes;
